import React from 'react';

import Typography from '@material-ui/core/Typography';
import CheckCircle from '@material-ui/icons/CheckCircle';

import { makeStyles } from '@material-ui/core/styles';
import Topic from '../Topic';

const useStyles = makeStyles((theme) => ({
  textStyle: {
    fontWeight: 'bold',
    fontSize: 20,
    color: '#161D4B',
  },
  text: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 0,
  },
  textMarginTop10: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 10,
  },
  icon: {
    marginLeft: '8px',
    marginBottom: '4px',
    verticalAlign: 'middle',
  },
}));

function ModalJustificationData() {
  const classes = useStyles();

  return (
    <div style={{ paddingHorizontal: 15, paddingTop: 15 }}>
      <div style={{ flex: 2 }}>
        <Typography className={classes.textStyle}>
          Para garantir a autenticidade das operações fiscais e financeiras,é
          necessária a confirmação e veracidade dos dados de pessoa física,
          juridica e informações de contato.
        </Typography>
      </div>
      <br />
      <div style={{ flex: 1 }} />
      <Topic text="Documentos necessários" />
      <Typography className={classes.text}>
        <CheckCircle htmlColor="green" className={classes.icon} />
        CPF
      </Typography>
      <Typography className={classes.text}>
        <CheckCircle htmlColor="green" className={classes.icon} />
        Data de nascimento
      </Typography>
      <Typography className={classes.text}>
        <CheckCircle htmlColor="green" className={classes.icon} />
        Nome da mãe
      </Typography>
      <Typography className={classes.text}>
        <CheckCircle htmlColor="green" className={classes.icon} />
        RG
      </Typography>
      <Typography className={classes.text}>
        <CheckCircle htmlColor="green" className={classes.icon} />
        Endereço
      </Typography>
      <Typography className={classes.text}>
        <CheckCircle htmlColor="green" className={classes.icon} />
        Telefone
      </Typography>
      <Typography className={classes.text}>
        <CheckCircle htmlColor="green" className={classes.icon} />
        CNPJ
      </Typography>
    </div>
  );
}

export default ModalJustificationData;
